import "@dotlottie/player-component";

import { ReactiveSet } from "@solid-primitives/set";
import {
  createContext,
  createEffect,
  ParentComponent,
  useContext,
} from "solid-js";

import loadingSquareLottie from "../assets/lottie/loading.lottie";

export const LoadingContext = createContext<{
  addLoader: (loaderKey: string) => void;
  removeLoader: (loaderKey: string) => void;
}>();

export const LoadingContextProvider: ParentComponent = (props) => {
  const loaders = new ReactiveSet<string>();

  const addLoader = (loaderKey: string) => {
    loaders.add(loaderKey);
  };

  const removeLoader = (loaderKey: string) => {
    loaders.delete(loaderKey);
  };

  let hideTimeoutId: number;
  createEffect(() => {
    if (loaders.size > 0) {
      document.getElementById("globalLoader")?.classList.remove("hidden");
      window.clearTimeout(hideTimeoutId);
    } else {
      hideTimeoutId = window.setTimeout(() => {
        document.getElementById("globalLoader")?.classList.add("hidden");
      }, 1000);
    }
  });

  return (
    <LoadingContext.Provider value={{ addLoader, removeLoader }}>
      <span
        id="globalLoader"
        // eslint-disable-next-line tailwindcss/no-contradicting-classname
        class="absolute inset-x-0 top-2 flex hidden items-center justify-center"
      >
        <span>
          <dotlottie-player
            autoplay
            loop
            mode="normal"
            src={loadingSquareLottie}
            class="w-44"
          />
        </span>
      </span>
      {props.children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
